import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/news-media/bannerNews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/news-media/bannerNewsCourse.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/news-media/latestNews.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/why-medh/Certified.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2379967965/src/medh-web/src/components/shared/wrappers/PageWrapper.tsx");
